/**
 * Frontend config. The single place that reads Vite env vars, so nothing is
 * hardcoded and every environment (local/dev/prod) is driven by VITE_* values.
 */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:3000",
  wsUrl: import.meta.env.VITE_WS_URL ?? "ws://localhost:3001",
  stage: import.meta.env.VITE_STAGE ?? "local",
} as const;
